import compose from "recompose/compose"
import withProps from "recompose/withProps"
import { addUrlProps, UrlQueryParamTypes } from "react-url-query"

const urlPropsQueryConfig = {
  recruiterType: { type: UrlQueryParamTypes.string },
  industry: { type: UrlQueryParamTypes.string },
  companySize: { type: UrlQueryParamTypes.string },
}

export default compose(
  addUrlProps({ urlPropsQueryConfig }),
  withProps(({ recruiterType, industry, companySize }) => ({
    initialRecruiterType: recruiterType,
    initialIndustryId: industry,
    initialCompanySizeId: companySize,
  })),
)
